import React, { createContext, useContext, useState } from 'react';

const LanguageContext = createContext();

const translations = {
 en: {
    videoTitle: "THE ART BEHIND YOUR SMILE",
    services: "Our Services",
    aboutUs: "About Us",
    contact: "Contact",
    gallery: "Gallery",
    whatsapp:"Whatsapp",
    // About Us Section
    aboutUsSubtitle: "WHO WE ARE",
    oralHealth: "Delivering Reliable and Healthy Smiles",
    oralHealthDesc: "We are here to provide the highest standards in dental health and aesthetics. By offering personalized solutions, we instill confidence in our patients' smiles.",
    estheticDentistry: "Smiles Meet Modern Technology",
    estheticDentistryDesc: "Our goal is to provide world-class services to both local and international patients by utilizing innovative technologies in dentistry.",
    implantDentistry: "Why Us? Because Your Smile is Our Priority",
    implantDentistryDesc: "With our experienced team, hygienic environments, and personalized treatment approaches, trust your dental health to expert hands. Your satisfaction is our motivation",
    // Contact Section
    contactUs: "Get in Touch",
    addressLabel: "Address",
    phoneLabel: "Phone",
    emailLabel: "Email",
    followUs: "Follow Us",
    facebook: "Facebook",
    tiktok: "Whatsapp",
    instagram: "Instagram",
    // Reviews Section
    reviewsTitle: "WHAT OUR PATIENTS SAY",
    reviewsSubtitle: "Patient Testimonials",
    // FAQ Section
    faqTitle: "FREQUENTLY ASKED QUESTIONS",
    faqSubtitle: "Things You Wonder About",
    // Cards translations
    teethCleaning: "Teeth Cleaning",
    teethCleaningDesc: "We offer professional teeth cleaning services to maintain oral hygiene.",
    implant: "Dental Implant",
    implantDesc: "We provide high-quality dental implants for missing teeth.",
    canalTreatment: "Canal Treatment",
    canalTreatmentDesc: "We perform root canal treatments to save damaged teeth.",
    filling: "Filling",
    fillingDesc: "We restore damaged teeth with durable fillings.",
    orthodonticTreatment: "Orthodontic Treatment",
    orthodonticTreatmentDesc: "We provide braces and other orthodontic treatments to straighten teeth.",
    smileDesign: "Smile Design",
    smileDesignDesc: "We offer smile makeover services for a beautiful, confident smile.",
    jawSurgery: "Jaw Surgery",
    jawSurgeryDesc: "We perform jaw surgeries to correct misalignment and improve function.",
    bot: "Teeth clenching and grinding",
    botDesc: "custom night guards and muscle relaxation techniques are used to protect the teeth and relieve symptoms."
  },
  tr: {
    videoTitle: "GÜLÜŞÜNÜZDEKİ GİZLİ SANAT",
    services: "Hizmetlerimiz",
    aboutUs: "Hakkımızda",
    contact: "İletişim",
    gallery: "Galeri",
    whatsapp:"Whatsapp",
    // About Us Section
    aboutUsSubtitle: "BİZ KİMİZ",
    oralHealth: "Güvenilir ve Sağlıklı Gülüşler Sunmak",
    oralHealthDesc: "Diş sağlığı ve estetiğinde en yüksek standartları sağlamak için buradayız. Hastalarımıza kişiselleştirilmiş çözümler sunarak, onların gülüşlerine güven katıyoruz..",
    estheticDentistry: "Modern Teknoloji ile Buluşan Gülüşler",
    estheticDentistryDesc: "Diş hekimliğinde yenilikçi teknolojileri kullanarak hem yerel hem de uluslararası hastalarımıza dünya standartlarında hizmet sunmayı hedefliyoruz.",
    implantDentistry: "Neden Biz? Çünkü Gülüşleriniz Bizim Önceliğimiz",
    implantDentistryDesc: "Deneyimli ekibimiz, hijyenik ortamlarımız ve kişiye özel tedavi yaklaşımlarımızla diş sağlığınızı emin ellere teslim edin. Sizin memnuniyetiniz bizim motivasyonumuz",
    // Contact Section
    contactUs: "Bize Ulaşın",
    addressLabel: "Adres",
    phoneLabel: "Telefon",
    emailLabel: "Email",
    followUs: "Bizi Takip Edin",
    facebook: "Facebook",
    tiktok: "Whatsapp",
    instagram: "Instagram",
    // Reviews Section
    reviewsTitle: "HASTALARIMIZ NE DİYOR?",
    reviewsSubtitle: "Hasta Yorumları",
    // FAQ Section
    faqTitle: "SIKÇA SORULAN SORULAR",
    faqSubtitle: "Merak Ettikleriniz",
    // Cards translations
    teethCleaning: "Diş Temizliği",
    teethCleaningDesc: "Ağız hijyenini korumak için profesyonel diş temizliği hizmeti sunuyoruz.",
    implant: "Diş İmplantı",
    implantDesc: "Kaybolan dişler için yüksek kaliteli diş implantları sağlıyoruz.",
    canalTreatment: "Kanal Tedavisi",
    canalTreatmentDesc: "Zarar gören dişleri kurtarmak için kanal tedavisi uyguluyoruz.",
    filling: "Dolgu",
    fillingDesc: "Zarar görmüş dişleri dayanıklı dolgularla onarıyoruz.",
    orthodonticTreatment: "Ortodontik Tedavi",
    orthodonticTreatmentDesc: "Dişlerinizi düzeltmek için braketler ve diğer ortodontik tedaviler sağlıyoruz.",
    smileDesign: "Gülüş Tasarımı",
    smileDesignDesc: "Güzel ve özgüvenli bir gülüş için gülüş tasarımı hizmeti sunuyoruz.",
    jawSurgery: "Çene Ameliyatı",
    jawSurgeryDesc: "Çene ameliyatları ile çene hizasını düzeltip fonksiyonu iyileştiriyoruz.",
    bot: "Diş sıkma ve gıcırdatma",
    botDesc: "özel gece plakları ve kas gevşetici yöntemler kullanılarak dişler korunur ve semptomlar hafifletilir."
  },
  ar: {
    videoTitle: "فَنّ الابتسامة وراءها",
    services: "خدماتنا",
    aboutUs: "معلومات عنا",
    contact: "اتصل بنا",
    gallery: "معرض الصور",
    whatsapp:"واتساب",
    // About Us Section
    aboutUsSubtitle: "من نحن",
    oralHealth: "مهمتنا: تقديم ابتسامات موثوقة وصحية",
    oralHealthDesc: "نحن هنا لتقديم أعلى معايير صحة الأسنان وجمالها. من خلال تقديم حلول مخصصة، نعزز ثقة مرضانا بابتساماتهم",
    estheticDentistry: "رؤيتنا: الابتسامات تلتقي بالتكنولوجيا الحديثة",
    estheticDentistryDesc: "هدفنا هو تقديم خدمات بمعايير عالمية للمرضى المحليين والدوليين من خلال استخدام تقنيات مبتكرة في طب الأسنان",
    implantDentistry: "لماذا نحن؟ لأن ابتسامتك هي أولويتنا",
    implantDentistryDesc: "مع فريقنا المتمرس وبيئتنا الصحية ونهجنا العلاجي المخصص، ضع صحة أسنانك بين أيدٍ خبيرة. رضاك هو حافزنا",
    // Contact Section
    contactUs: "اتصل بنا",
    addressLabel: "العنوان",
    phoneLabel: "الهاتف",
    emailLabel: "البريد الإلكتروني",
    followUs: "تابعنا",
    facebook: "فيسبوك",
    tiktok: " واتساب",
    instagram: "إنستجرام",
    // Reviews Section
    reviewsTitle: "ماذا يقول مرضانا؟",
    reviewsSubtitle: "شهادات المرضى",
    // FAQ Section
    faqTitle: "الأسئلة المتكررة",
    faqSubtitle: "الأشياء التي تتساءلون عنها",
    // Cards translations
    teethCleaning: "تنظيف الأسنان",
    teethCleaningDesc: "نقدم خدمات تنظيف الأسنان للحفاظ على نظافة الفم",
    implant: "زرع الأسنان",
    implantDesc: "نقدم زراعة الأسنان عالية الجودة للأسنان المفقودة",
    canalTreatment: "علاج قناة الجذر",
    canalTreatmentDesc: "نقوم بعلاج قناة الجذر لإنقاذ الأسنان التالفة",
    filling: "حشو الأسنان",
    fillingDesc: "نقوم بترميم الأسنان التالفة باستخدام الحشوات المتينة",
    orthodonticTreatment: "علاج تقويم الأسنان",
    orthodonticTreatmentDesc: "نقدم تقويم الأسنان والخدمات الأخرى لتعديل الأسنان",
    smileDesign: "تصميم الابتسامة",
    smileDesignDesc: "نقدم خدمات تحسين الابتسامة للحصول على ابتسامة جميلة وواثقة",
    jawSurgery: "جراحة الفك",
    jawSurgeryDesc: "نقوم بإجراء جراحة الفك لتصحيح المحاذاة وتحسين الوظيفة",
    bot: "صرير الأسنان",
    botDesc: "يتم استخدام واقيات ليلية مخصصة وتقنيات إرخاء العضلات لحماية الأسنان وتخفيف الأعراض"
  },
  ru: {
    videoTitle: "ИСКУССТВО ЗА ВАШЕЙ УЛЫБКОЙ",
    services: "Наши услуги",
    aboutUs: "О нас",
    contact: "Контакты",
    gallery: "Галерея",
    whatsapp:"Whatsapp",
    // About Us Section
    aboutUsSubtitle: "КТО МЫ",
    oralHealth: "Наша миссия: Дарить надежные и здоровые улыбки",
    oralHealthDesc: "Мы здесь, чтобы обеспечить высочайшие стандарты здоровья и эстетики зубов. Предлагая персонализированные решения, мы укрепляем уверенность в улыбках наших пациентов.",
    estheticDentistry: " Наше видение: Улыбки встречаются с современными технологиями",
    estheticDentistryDesc: "Наша цель — предоставлять услуги мирового уровня местным и международным пациентам, используя инновационные технологии в стоматологии.",
    implantDentistry: "Почему мы? Потому что ваша улыбка — наш приоритет",
    implantDentistryDesc: "С нашей опытной командой, гигиеническими условиями и индивидуальным подходом к лечению доверьте своё здоровье зубов в надежные руки. Ваше удовлетворение — наша мотивация",
    // Contact Section
    contactUs: "Свяжитесь с нами",
    addressLabel: "Адрес",
    phoneLabel: "Телефон",
    emailLabel: "Электронная почта",
    followUs: "Подпишитесь на нас",
    facebook: "Facebook",
    tiktok: "Whatsapp",
    instagram: "Instagram",
    // Reviews Section
    reviewsTitle: "ЧТО ГОВОРЯТ НАШИ ПАЦИЕНТЫ",
    reviewsSubtitle: "Отзывы пациентов",
    // FAQ Section
    faqTitle: "ЧАСТО ЗАДАВАЕМЫЕ ВОПРОСЫ",
    faqSubtitle: "То, что вас интересует",
    // Cards translations
    teethCleaning: "Чистка зубов",
    teethCleaningDesc: "Мы предлагаем профессиональную чистку зубов для поддержания гигиены полости рта.",
    implant: "Стоматологический имплант",
    implantDesc: "Мы предоставляем высококачественные стоматологические имплантаты для утраченных зубов.",
    canalTreatment: "Лечение каналов",
    canalTreatmentDesc: "Мы проводим лечение корневых каналов для сохранения поврежденных зубов.",
    filling: "Пломба",
    fillingDesc: "Мы восстанавливаем поврежденные зубы с помощью прочных пломб.",
    orthodonticTreatment: "Ортодонтическое лечение",
    orthodonticTreatmentDesc: "Мы предлагаем брекеты и другие ортодонтические методы для выравнивания зубов.",
    smileDesign: "Дизайн улыбки",
    smileDesignDesc: "Мы предлагаем услуги по созданию красивой и уверенной улыбки.",
    jawSurgery: "Операция на челюсти",
    jawSurgeryDesc: "Мы проводим операции на челюсти для коррекции смещения и улучшения функции.",
    bot: "сжатия и скрежетания зубами",
    botDesc: "используются специальные ночные каппы и методы расслабления мышц для защиты зубов и облегчения симптомов."
  },
};


export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState('tr'); // Default language is Turkish

  const changeLanguage = (lang) => {
    setLanguage(lang); // Change the language state
  };

  return (
    <LanguageContext.Provider value={{ language, translations, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLanguage = () => useContext(LanguageContext);
